import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private _config: any;
  
  constructor(private http: HttpClient) {}

  loadConfig(): Promise<void> {
    return this.http.get('assets/config.json').toPromise()
      .then(config => {
        this._config = config;
      });
  }

  
  get getVersion(): string {
    return this._config.version ? this._config.version : "1.0.0";
  }

  get siteName(): string {
    return this._config.siteName;
  }

  get apiConfig(): ApiConfig {
   // const found = this._config.apiUrl.find((item: ApiConfig) => item.name === this._config.siteName);
    const found = environment.apiUrl.find((item: ApiConfig) => item.name === this._config.siteName);
    return found ? found : { name: "", url: "", token: "", description: "" };
  }

  
  get apiSSOAuth(): string {
    const found = environment.apiSSOAuth.find((item: ApiSSOAuth) => item.name === this._config.siteName);    
    return found ? found.url : "";
  }


  get apiCurriculumConfig(): ApiCurrConfig {
    const found = environment.apiCurriculum.find((item: ApiCurrConfig) => item.name === this._config.siteName);
    return found ? found : { name: "", url: "", token: "", openCurriculum: false };
  }

  get apiPVConfig(): ApiPVConfig {
    const found = environment.apiPV.find((item: ApiPVConfig) => item.name === this._config.siteName);    
    return found ? found : { name: "", url: "", token: "", openPV: false};
  }

  get defaultLocationID(): string{
    const found = environment.defaultLocation.find((item: DefaultLocation) => item.name === this._config.siteName);
    return found ? found.defaultLocationID : ""
  }

  get defaultLocationName(): string{
    const found = environment.defaultLocation.find((item: DefaultLocation) => item.name === this._config.siteName);
    return found ? found.defaultLocationName : "";
  }

  get openSelfCheck(): boolean {
    const found = environment.openSelfCheck.find((item: OpenSelfCheck) => item.name === this._config.siteName);
    return found ? found.openSelfCheck : false;
  }

  get useWalaiBookCover(): string {
    const found = environment.useWalaiBookCover.find((item: useWalaiBookCover) => item.name === this._config.siteName);
    return found ? found.useWalaiBookCover : "0";
  }

  get displayBookResult(): DisplayBookResult{
    const found = environment.displayBookResult.find((item: DisplayBookResult) => item.name === this._config.siteName);
    return found ? found : { name: "", value: "", description: "" };
  }

  get measurementId(): string {
    const found = environment.MeasurementID.find((item: GoogleAnalytics) => item.name === this._config.siteName);
    return found ? found.id : "";
  }  


  get cookieConsent(): boolean {
    const found = environment.cookieConsent.find((item: CookieConsent) => item.name === this._config.siteName);
    return found ? found.used : false;
  }

  get cookieConsentId(): string {
    const found = environment.cookieConsent.find((item: CookieConsent) => item.name === this._config.siteName);
    return found ? found.data : "";
  }
}


export interface ApiConfig {
  name: string;
  url: string;
  token: string;
  description: string;
}

export interface ApiSSOAuth {
  name: string;
  url: string;
  token: string;
  description: string;
}

export interface ApiCurrConfig {
  name: string;
  url: string;
  token: string;
  openCurriculum: boolean;
}

export interface ApiPVConfig {
  name: string;
  url: string;
  token: string;
  openPV: boolean;
}

export interface DisplayBookResult {
  name: string;
  value: string;
  description: string;
}

export interface DefaultLocation {
  name: string;
  defaultLocationID: string;
  defaultLocationName: string;
}


export interface GoogleAnalytics {
  name: string;
  id: string;
  description: string;
}

export interface useWalaiBookCover {
  name: string;
  useWalaiBookCover: string;
  description: string;
}

export interface OpenSelfCheck {
  name: string;
  openSelfCheck: boolean;
  description: string;
}

export interface CookieConsent {
  name: string;
  data: string;
  used: boolean;
}